<app-transaction *ngIf="english"></app-transaction>
<app-transaction-hindi *ngIf="hindi"></app-transaction-hindi> 